import _uniq from 'lodash/uniq';

import { ExamGridModel, FileModel, TagModel } from 'models';

import { DocumentCategories } from 'features/exam/constants';

import { flattenTags } from './tagHelperUtils';

// Define unique negative IDs for dynamic tags and parents
export const ROOT_CATEGORY_TAG_ID = -1000;
// Adjust start ID if more parents are added - this might not be needed anymore if only category is dynamic
export const DYNAMIC_TAGS_START_ID = -1001; // Or just use ROOT_CATEGORY_TAG_ID if no other dynamic roots

// Define dynamic parent tag structures
export const ROOT_TAG_DEFINITIONS: Omit<TagModel, 'children'>[] = [
  { id: ROOT_CATEGORY_TAG_ID, name: 'File Category', active: true },
  // Removed Exam Service, Organ, Laterality root tags
];

// Mapping from DocumentCategory *values* (IDs) to desired dynamic tag *names*
export const CATEGORY_VALUE_TO_DYNAMIC_TAG_NAME: Record<number, string> = {};
Object.values(DocumentCategories).forEach((cat) => {
  if (cat && typeof cat === 'object' && typeof cat.value === 'number' && typeof cat.name === 'string') {
    CATEGORY_VALUE_TO_DYNAMIC_TAG_NAME[cat.value] = cat.name;
  }
});

// Removed getOrganName, getLateralityName

// --- Function to get derived tag names --- //
// This function is now simplified to only potentially handle category if needed,
// or can be removed if categories are not treated as tags anymore.
// For now, let it return an empty array as we are moving away from derived tags.
export const getDerivedTagNamesForFile = (file: FileModel, exam?: ExamGridModel): string[] => {
  // const derivedTagNames = new Set<string>();
  // if (file.categoryId != null) {
  //   const categoryName = CATEGORY_VALUE_TO_DYNAMIC_TAG_NAME[file.categoryId];
  //   if (categoryName) derivedTagNames.add(categoryName);
  // }
  // All other derived tag logic (exam service, organ, laterality) is removed.
  return []; // Return empty array, effectively disabling derived tags
};
